import { render, staticRenderFns } from "./editPersonal.vue?vue&type=template&id=f465dcf4&scoped=true&"
import script from "./editPersonal.vue?vue&type=script&lang=js&"
export * from "./editPersonal.vue?vue&type=script&lang=js&"
import style0 from "./editPersonal.vue?vue&type=style&index=0&id=f465dcf4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f465dcf4",
  null
  
)

export default component.exports